var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content content-wrapper"},[(_vm.hasPFTheme)?_c('PayfastLoader',{attrs:{"instruction":_vm.instruction}}):_c('SidLoader',{attrs:{"instruction":_vm.instruction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }